<gen-navigation-ui
  *ngIf="data$ | async as data"
  [node]="data?.nodes"
  [logo]="data?.logo"
  [flyout]="false"
  [ngClass]="data?.styleClass ?? ''"
  [navAriaLabel]="'navigation.footerNavLabel' | cxTranslate"
  class="footer-navigation"
></gen-navigation-ui>
